import React, { useEffect, useState } from 'react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-navy/95 backdrop-blur-md border-t border-white/10 md:hidden animate-slide-up" data-id="element-436">
      <div className="px-4 py-3" data-id="element-437">
        <a href="https://www.godeskcore.com/cart/42794527916080:1" target="_blank" rel="noopener noreferrer" className="w-full block" data-id="element-438">
          <button className="w-full bg-cta text-white font-bold min-h-[48px] py-3 px-4 rounded-lg shadow-lg active:scale-[0.98] transition-transform flex items-center justify-center gap-2 uppercase tracking-wide text-sm" data-id="element-439">
            <span data-id="element-440">🔒 DESCARGA EBOOK + 3 BONOS — $17.95</span>
          </button>
        </a>
      </div>
    </div>;
}